module.exports = __webpack_public_path__ + "static/media/shiprocket-icon.83cc9cc1.png";